module.exports = __webpack_public_path__ + "assets/img/ziraatbankasi@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/ziraatbankasi@2x.png
// module id = 147
// module chunks = 0